import { render, staticRenderFns } from "./SectionDispatch.vue?vue&type=template&id=63b07e09&scoped=true"
import script from "./SectionDispatch.vue?vue&type=script&lang=ts"
export * from "./SectionDispatch.vue?vue&type=script&lang=ts"
import style0 from "./SectionDispatch.vue?vue&type=style&index=0&id=63b07e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b07e09",
  null
  
)

export default component.exports